import { useTrpc } from '@client/hooks/api/useTrpc';
import { RiskActionPlanEdit } from '@client/routes/~console.$orgId/~risk/~register/~details.$id/RiskActionPlan/RiskActionPlanEdit';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/workload-manager/tasks/calendar/details/risk_action/$id')({
    staticData: {
        metadata: {
            title: 'Risk action plan details',
        },
        presentation: 'overlay',
    },
    params: {
        parse({ id }) {
            return { id: BigInt(id) };
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    const { id } = Route.useParams();
    const { trpc } = useTrpc();

    // Get the workload item to find the risk ID
    const { data: workloadItem } = trpc.workloadManager.listWorkloadItems.useQuery({
        where: { id, workItemType: 'risk_action' },
        limit: 1,
        offset: 0,
    });

    const item = workloadItem?.rows[0];

    if (!item) {
        return null;
    }

    return (
        <RiskActionPlanEdit
            action={['edit', id]}
            riskId={item.recordId ?? BigInt(0)}
            onClose={() => window.history.back()}
            workloadItem={item}
        />
    );
}
